import { useState, useEffect, useRef } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';
import './NavBar.css';

export const NavBar = () => {

  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const toggleRef = useRef(null);
  const firstLinkRef = useRef(null);
  const previousExpandedRef = useRef(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.classList.toggle('mobile-nav-open', expanded);

    return () => {
      document.body.classList.remove('mobile-nav-open');
    };
  }, [expanded]);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        setExpanded(false);
      }
    };

    if (expanded) {
      window.addEventListener('keydown', onKeyDown);
    }

    return () => {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [expanded]);

  useEffect(() => {
    if (expanded && !previousExpandedRef.current) {
      firstLinkRef.current?.focus();
    }

    if (!expanded && previousExpandedRef.current) {
      toggleRef.current?.focus();
    }

    previousExpandedRef.current = expanded;
  }, [expanded]);

  const handleLinkClick = (value) => {
    setActiveLink(value);
    setExpanded(false);
  };

  return (
    <Navbar
      expand="md"
      expanded={expanded}
      onToggle={(nextExpanded) => setExpanded(nextExpanded)}
      className={`${scrolled ? "scrolled" : ""} ${expanded ? "menu-open" : ""}`.trim()}
    >
      <Container>
        <Navbar.Brand href="/">
          <h3 className="nav-brand-title">PORTFOLIO</h3>
        </Navbar.Brand>
        <Navbar.Toggle
          ref={toggleRef}
          aria-controls="basic-navbar-nav"
          aria-label="Toggle navigation menu"
          aria-expanded={expanded}
        >
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto navbar-tab" role="menu">
            <Nav.Link
              ref={firstLinkRef}
              href="#home"
              role="menuitem"
              aria-current={activeLink === 'home' ? 'page' : undefined}
              className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'}
              onClick={() => handleLinkClick('home')}
            >
              Home
            </Nav.Link>
            <Nav.Link
              href="#about"
              role="menuitem"
              aria-current={activeLink === 'about' ? 'page' : undefined}
              className={activeLink === 'about' ? 'active navbar-link' : 'navbar-link'}
              onClick={() => handleLinkClick('about')}
            >
              About
            </Nav.Link>
            <Nav.Link
              href="#projects"
              role="menuitem"
              aria-current={activeLink === 'projects' ? 'page' : undefined}
              className={activeLink === 'projects' ? 'active navbar-link' : 'navbar-link'}
              onClick={() => handleLinkClick('projects')}
            >
              Projects
            </Nav.Link>
            <Nav.Link
              href="https://medium.com/@kaveeshadhanasekara"
              role="menuitem"
              aria-current={activeLink === 'blogs' ? 'page' : undefined}
              className={activeLink === 'blogs' ? 'active navbar-link' : 'navbar-link'}
              target="_blank"
              rel="noreferrer"
              onClick={() => handleLinkClick('blogs')}
            >
              Blog
            </Nav.Link>
            <Nav.Link
              href="#connect"
              role="menuitem"
              aria-current={activeLink === 'connect' ? 'page' : undefined}
              className={activeLink === 'connect' ? 'active navbar-link' : 'navbar-link'}
              onClick={() => handleLinkClick('connect')}
            >
              Contact
            </Nav.Link>
          </Nav>
          <span className="navbar-text">
            <div className="social-icon" aria-label="Social links">
              <a href="https://www.linkedin.com/in/kaveesha-dhanasekara/" target="_blank" rel="noreferrer" onClick={() => setExpanded(false)}><img src={navIcon1} alt="LinkedIn" /></a>
              <a href="https://github.com/AbstractLK" target="_blank" rel="noreferrer" onClick={() => setExpanded(false)}><img src={navIcon2} alt="GitHub" /></a>
              <a href="https://medium.com/@kaveeshadhanasekara" target="_blank" rel="noreferrer" onClick={() => setExpanded(false)}><img src={navIcon3} alt="Medium" /></a>
            </div>
          </span>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
